import * as Routes from '@routes';
import request from '@util/request';

export const createSingleInvite = (event, body) =>
  request.post(Routes.organisersEventRedeemCodesPath(event), body);
export const sendTestRedeemCodeEmail = event =>
  request.post(Routes.sendTestEmailOrganisersEventRedeemCodesPath(event));
